module.exports = __webpack_public_path__ + "static/media/13_profile_picture.2c7234bc.png";